import { Snackbar } from '@elementary/common-ui/components';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import useSnackbar from '@/shared/hooks/useSnackbar';
import ErrorPage from './ErrorPage';

const ReportShell = () => {
  const { snackbar, closeSnackbar } = useSnackbar();

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => (
        <ErrorPage error={error} page={'ReportShell'} />
      )}
    >
      <Outlet />
      <Snackbar {...snackbar} onClose={closeSnackbar} />
    </ErrorBoundary>
  );
};

export default ReportShell;
